import { reactive } from '@vue/composition-api';
import { Optional } from 'frontend/types';
import { Banner, BannerResponse, QueryParams } from 'frontend/types/banners';
import { getJson } from 'frontend/utils/ajax';
import { appendGetParams } from 'frontend/utils/urls';

export default async function useBanners(
  currentRoutePath: string,
  q: QueryParams = {},
): Promise<Optional<Banner>> {
  const banner: Banner = reactive({
    text: '',
    theme: 'generic-banner',
    dismissable: false,
    tracking_element_id: '',
    open_link_in_new_tab: false,
    is_sticky: false,
  });
  const bannerResponse: BannerResponse = reactive({
    banner,
  });
  const url = '/api/v4/banners/';
  const queryParams: QueryParams = { route: currentRoutePath };
  const finalUrl = appendGetParams(url, queryParams);
  const data = await getJson(finalUrl);
  bannerResponse.banner = data.banner;
  return bannerResponse.banner;
}
